import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../../../config/queryKeys'
import { getPlayerWaiver } from '../../../../../services/player/playerWaiver'

/**
 * One waiver signature in full: GET /players/:id/waivers/:waiverId. Fetched
 * only while a waiver is open, so the tables load without it.
 */
export const usePlayerWaiver = (
  playerId: string | undefined,
  waiverId: string | null
) =>
  useQuery({
    queryKey: queryKeys.playerDetails.waiver(playerId, waiverId),
    queryFn: () => getPlayerWaiver(playerId as string, waiverId as string),
    enabled: Boolean(playerId && waiverId),
  })
